import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Gtag } from 'angular-gtag';

@Component({
    selector: 'app-mobile-warning',
    templateUrl: './mobile-warning.component.html',
    styleUrls: ['./mobile-warning.component.scss']
})
export class MobileWarningComponent {

    constructor(private readonly dialogRef: MatDialogRef<MobileWarningComponent>, private readonly gtag: Gtag) {
        this.gtag.event('mobile_warning_created', {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            event_category: 'mobile'
        });
    }

    public dismiss() {
        this.gtag.event('mobile_warning_dismissed', {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            event_category: 'mobile'
        });
        this.dialogRef.close();
    }

}
